import React, { useState, useEffect } from "react";
import {
  Container,
  Collapse,
  NavbarToggler,
  NavItem,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Button,
} from "reactstrap";
import { MsalProvider } from "@azure/msal-react";
import { Link, withRouter } from "react-router-dom";
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig, loginApiRequest } from "../../authConfig";
import logo from "../../assets/Logo.png";

import LanguageIcon from "../../assets/Language.png";
import SignIn from "../../assets/Sing_In.png";

import { useTranslation } from "react-i18next";
import { useCookies } from "react-cookie";
import i18next from "i18next";
import {
  useGetRoleAndNameQuery,
  useGetRoleQuery,
  getRole,
  getMyRoleAndName,
} from "../../services/admin.service";
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from "@azure/msal-react";

import { SignInButton } from "./SignInButton";
import { SignOutButton } from "./SignOutButton";

const msalInstance = new PublicClientApplication(msalConfig);
const account = msalInstance.getAllAccounts()[0];

const NavBar = (props) => {
  const isRtl = i18next.language === "ar";
  const { i18n, t } = useTranslation();
  const [cookies, setCookie] = useCookies(["i18next"]);
  //user Profile Dropdown
  const [userProfile, setUserProfile] = useState(false);
  const dropDownuserprofile = () => setUserProfile((prevState) => !prevState);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggleLanguage = () => setDropdownOpen((prevState) => !prevState);
  const [isOpen, setIsOpen] = useState(false);

  //-------------------------------------------
  const { data: { body: roles = [] } = {} } = useGetRoleQuery();
  const { data: { body: names = [] } = {} } = useGetRoleAndNameQuery();

  sessionStorage.setItem("KKFGroups", JSON.stringify(names?.groups));
  const toggle = () => {
    return setIsOpen(!isOpen);
  };
  const doChangeLanguage = (lang) => {};

  const getLang = () => i18n.language || window.localStorage.i18nLng;

  useEffect(() => {
    if (!localStorage.getItem("i18nextLng")) {
      localStorage.setItem("i18nextLng", "ar");
    }
    changeLanguage(localStorage.getItem("i18nextLng"));
  }, []);

  const changeLanguage = (lang) => {
    i18n.changeLanguage(lang).then(() => {
      setCookie("i18next", lang);
      localStorage.setItem("i18nextLng", lang);
      if (lang === "ar") {
        setCookie("i18next", lang);
        document.documentElement.setAttribute("dir", "rtl");
        document.documentElement.setAttribute("lang", "ar");
        document.getElementById(
          "app-style"
        ).href = `assets/css/app-rtl.min.css`;
        document.getElementById(
          "bootstrap-style"
        ).href = `assets/css/bootstrap-rtl.min.css`;
      } else {
        setCookie("i18next", lang);
        document.getElementsByTagName("html")[0].removeAttribute("dir");
        document.documentElement.setAttribute("lang", "en");
        document.getElementById("app-style").href = `assets/css/app.min.css`;
        document.getElementById(
          "bootstrap-style"
        ).href = `assets/css/bootstrap.min.css`;
      }
    });
  };

  //menu activation

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    var matchingMenuItem = null;
    var ul = document.getElementById("navbarCollapse");
    var items = ul.getElementsByTagName("a");
    removeActivation(items);
    for (var i = 0; i < items.length; ++i) {
      if (props.location.pathname === items[i].pathname) {
        matchingMenuItem = items[i];
        break;
      }
    }

    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem);
    }
  });
  const removeActivation = (items) => {
    for (var i = 0; i < items.length; ++i) {
      var item = items[i];
      const parent = items[i].parentElement;
      if (item && item.classList.contains("active")) {
        item.classList.remove("active");
      }
      if (parent) {
        if (parent.classList.contains("active")) {
          parent.classList.remove("active");
        }
      }
    }
  };

  function activateParentDropdown(item) {
    item.classList.add("active");
    const parent = item.parentElement.parentElement.parentElement;

    if (parent) {
      parent.classList.add("active"); // li
      const parent2 = parent.parentElement;
      parent2.classList.add("active"); // li
      const parent3 = parent2.parentElement;
      if (parent3) {
        parent3.classList.add("active"); // li
        const parent4 = parent3.parentElement;
        if (parent4) {
          parent4.classList.add("active"); // li
          const parent5 = parent4.parentElement;
          if (parent5) {
            parent5.classList.add("active"); // li
            const parent6 = parent5.parentElement;
            if (parent6) {
              parent6.classList.add("active"); // li
            }
          }
        }
      }
    }
    return false;
  }

  return (
    <React.Fragment>
      <nav
        className={"navbar navbar-expand-lg fixed-top sticky p-0 nav-sticky"}
        id="navigation"
        style={{ direction: "ltr", zIndex:'1010' }}
      >
        <Container fluid className="custom-container">
          <ul className="mx-5 header-menu list-inline d-flex align-items-center mb-0">
            <li className="list-inline-item align-middle">
              <Dropdown
                onClick={() => setUserProfile(!userProfile)}
                isOpen={userProfile}
                toggle={dropDownuserprofile}
                className="list-inline-item"
                style={{ color: "#1a3428" }}
              >
                {/* Unauthenticated Template */}
                <UnauthenticatedTemplate>
                  <DropdownToggle
                    to="#"
                    className="header-item"
                    id="userdropdown"
                    type="button"
                    tag="a"
                    aria-expanded="false"
                    style={{ color: "#1a3428" }}
                  >
                    <div style={{ padding: "0px", margin: "0px" }}>
                      <img
                        src={SignIn}
                        height="40"
                        alt="logo"
                        width="40"
                        className="logo-dark"
                      />
                    </div>
                    <SignInButton groups={names?.groups} />
                  </DropdownToggle>
                </UnauthenticatedTemplate>

                {/* Authenticated Template */}
                <AuthenticatedTemplate>
                  <DropdownToggle
                    to="#"
                    className="header-item"
                    id="userdropdown"
                    type="button"
                    tag="a"
                    aria-expanded={userProfile} // Ensure the expanded state is tied to `userProfile`
                    style={{ color: "#1a3428",zIndex:'1010' }}
                  >
                    <img
                      src={SignIn}
                      height="40"
                      alt="logo"
                      width="40"
                      className="logo-dark"
                      style={{
                        padding: "0px",
                        margin: "0px",
                        display: "block",
                        zIndex:'1010'
                      }}
                    />
                    {i18next.language === "en" ? "Hi, " : "مرحبا ,"}{" "}
                    {i18next.language === "en" ? names?.name : names?.nameAr}
                  </DropdownToggle>

                  {/* Dropdown Menu */}
                  <DropdownMenu
                    className="dropdown-menu-end"
                    aria-labelledby="userdropdown"
                    end
                  >
                    <span>{t("role")}</span>
                    <hr />
                    <ul>
                      {roles?.map((role, key) => {
                        return (
                          <li key={key}>
                            <span>
                              {role.name === "Recruiter"
                                ? t("Recruiter")
                                : role.name === "ReportOwner"
                                ? t("Report_owner")
                                : role.name === "HiringManager"
                                ? t("Hiring_manager")
                                : role.name === "HRManager"
                                ? t("HR_Manager")
                                : role?.name === "Admin"
                                ? t("Admin")
                                : role?.name === "PendingApproval"
                                ? t("PendingApproval")
                                : null}
                            </span>
                          </li>
                        );
                      })}
                    </ul>
                    <hr />
                    <SignOutButton groups={names?.groups} />
                  </DropdownMenu>
                </AuthenticatedTemplate>
              </Dropdown>

              <Dropdown
                isOpen={dropdownOpen}
                toggle={toggleLanguage}
                className="d-inline-block language-switch"
              >
                <DropdownToggle
                  tag="button"
                  type="button"
                  className="btn"
                  style={{ color: "#1a3428", marginTop: "-35px" }}
                >
                  <div style={{ padding: "0px", margin: "0px" }}>
                    <img
                      src={LanguageIcon}
                      height="40"
                      alt="logo"
                      width="40"
                      className="logo-dark"
                    />
                  </div>
                  {i18next.language === "en" ? (
                    <a
                      style={{ fontFamily: "Suisse" }}
                      type="button"
                      aria-expanded="false"
                      aria-haspopup="true"
                      to="/"
                      data-lang="sp"
                      onClick={() => {
                        changeLanguage("ar");
                        doChangeLanguage("ar");
                      }}
                    >
                      العربية
                    </a>
                  ) : (
                    <a
                      style={{ fontFamily: "Suisse" }}
                      type="button"
                      aria-expanded="false"
                      aria-haspopup="true"
                      to="/"
                      data-lang="eng"
                      onClick={() => {
                        changeLanguage("en");
                        doChangeLanguage("en");
                      }}
                    >
                      English
                    </a>
                  )}
                </DropdownToggle>
              </Dropdown>
            </li>
          </ul>

          <div>
            <NavbarToggler
              className="me-3"
              type="button"
              onClick={() => toggle()}
            >
              <i className="mdi mdi-menu" style={{ color: "#1a3428 " }}></i>
            </NavbarToggler>
          </div>
          <Collapse
            isOpen={isOpen}
            className="navbar-collapse"
            id="navbarCollapse"
            dir={isRtl ? "rtl" : ""}
          >
            <ul className="navbar-nav mx-auto navbar-center">
              {/* <AuthenticatedTemplate> */}
              <NavItem className="dropdown-hover pt-2">
                <Link className="nav-link" to="/">
                  {t("Home")}
                </Link>
              </NavItem>
              {/* </AuthenticatedTemplate> */}

              <AuthenticatedTemplate>
                <NavItem className="dropdown-hover pt-2">
                  <Link className="nav-link" to="/dashboard">
                    {t("dashboard")}
                  </Link>
                </NavItem>
              </AuthenticatedTemplate>

              <NavItem className="dropdown-hover pt-2">
                <a
                  className="nav-link"
                  rel="noreferrer"
                  href={
                    isRtl
                      ? "https://www.kkf.org.sa/%D8%A7%D8%AA%D8%B5%D9%84-%D8%A8%D9%86%D8%A7/"
                      : "https://www.kkf.org.sa/en/contact/"
                  }
                  target="_blank"
                >
                  {t("contact")}
                </a>
              </NavItem>
            </ul>
          </Collapse>

          <a
            className="navbar-brand text-dark fw-bold me-auto"
            target="_blank"
            rel="noreferrer"
            href={
              isRtl ? "https://www.kkf.org.sa/" : "https://www.kkf.org.sa/en/"
            }
          >
            <img
              src={logo}
              // height="60"
              alt="logo"
              width="320"
              className="logo-dark"
            />
            <img
              src={logo}
              width="320"
              alt="logo"
              // width="100%"
              className="logo-light"
            />
          </a>
          {/* ------------- */}
        </Container>
      </nav>
    </React.Fragment>
  );
};

export default withRouter(NavBar);
